import { render, staticRenderFns } from "./adList.vue?vue&type=template&id=422569a2&scoped=true"
import script from "./adList.vue?vue&type=script&lang=js"
export * from "./adList.vue?vue&type=script&lang=js"
import style0 from "./adList.vue?vue&type=style&index=0&id=422569a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422569a2",
  null
  
)

export default component.exports